"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficePdftemplates_de_de = void 0;
function backofficePdftemplates_de_de() {
    return {
        "backoffice.pdftemplates.template.title": "Titel der PDF Vorlage",
        "backoffice.pdftemplates.title": "PDF Vorlagen",
        "backoffice.pdftemplates.subtitle": "Erstellen und verwalten Sie PDF Vorlagen für z.B. Ihre Rechnungen.",
        "backoffice.pdftemplates.create.title": "PDF Vorlage erstellen",
        "backoffice.pdftemplates.creationdialog.title": "PDF Vorlage erstellen",
        "backoffice.pdftemplates.creationdialog.description": "Titel eingeben, um PDF Vorlage zu erstellen",
        "backoffice.pdftemplates.deletion.title": "PDF Vorlage löschen",
        "backoffice.pdftemplates.deletion.message": "Möchten Sie diese PDF Vorlage wirklich löschen?",
        "backoffice.pdftemplates.edit.title": "PDF Vorlage bearbeiten",
        "backoffice.pdftemplates.editor.title.label": "PDF Vorlagentitel"
    };
}
exports.backofficePdftemplates_de_de = backofficePdftemplates_de_de;
